import React, { useRef } from 'react';
import { Link } from 'react-router-dom'

import SearchBox from '../../components/psc/lib/SearchBox'
import GncDataTable from '../../components/psc/lib/GncDataTable'
import useTableSlots from '../../hooks/useTableSlots'
import useBrowserTabTitle from '../../hooks/useBrowserTabTitle'

const ReportSchemes = () => {
    useBrowserTabTitle('Report Schemes')

    const table = useRef(null)
    const urlGetData = '/v0/report_schemes'
    const localStorageOrderKey = 'tblReportSchemesOrder'
    const defaultOrder = [[ 0, 'asc' ]]

    const {
        linkSlot,
    } = useTableSlots()

    const columns = [
        { data: 'name' },
        { data: 'has_stages' },
        { data: 'template.filename' }
    ]

    const tableHead = (
        <tr>
            <th>Name</th>
            <th>Output</th>
            <th>Template</th>
        </tr>
    )

    const tableSlots = {
        0: (data, type, row) => linkSlot(data, type, row, `/cadm/report_schemes/${row.id}`),
        1: (data, type, obj) => {
            if( data ) {
                return 'Tracking Report'
            } else {
                return 'Status Report'
            }
        },
        2: (data, type, obj) => linkSlot(data, type, obj, `/cadm/templates/${obj.template.id}`),
    }

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Report Schemes</h2>
                            
                            <div className="pre-table-buttons">
                                <Link to="/cadm/report_schemes/new" className="btn btn-mr btn-primary" type="button">New Report Scheme</Link>
                                <Link to="/cadm/report_types">Report Types</Link>
                                <Link to="/cadm/templates">Manage Templates</Link>
                            </div>
                            
                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                            </div>

                            <GncDataTable
                                tableRef={table}
                                dataUrl={urlGetData}
                                defaultOrder={defaultOrder}
                                localStorageOrderKey={localStorageOrderKey}
                                columns={columns}
                                tableSlots={tableSlots}
                                tableHead={tableHead}
                                tableFoot={tableHead}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ReportSchemes
